(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var root=document.querySelector('[data-lbx-catalog]');
    if(!root)return;
    var scrollKey='lbx99CatalogScroll';
    try{
      var savedRaw=sessionStorage.getItem(scrollKey);
      if(savedRaw){
        var saved=JSON.parse(savedRaw);
        sessionStorage.removeItem(scrollKey);
        if(saved && Date.now()-Number(saved.t||0)<12000){
          if('scrollRestoration' in history)history.scrollRestoration='manual';
          requestAnimationFrame(function(){window.scrollTo(0,Math.max(0,Number(saved.y||0)));});
        }
      }
    }catch(e){}
    var panel=root.querySelector('[data-lbx-filter-panel]');
    var triggers=[].slice.call(root.querySelectorAll('[data-lbx-open-filters]'));
    var closers=[].slice.call(root.querySelectorAll('[data-lbx-close-filters]'));
    var form=root.querySelector('[data-lbx-filter-form]');
    var backdrop=root.querySelector('.lbxv5-filter-backdrop') || document.querySelector('.lbxv5-filter-backdrop');
    var submitting=false;

    function norm(value){
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'')
        .replace(/[^a-z0-9]+/g,' ')
        .replace(/\s+/g,' ')
        .trim();
    }

    function labelForInput(input){
      var label=input.closest('label');
      if(!label)return '';
      var named=label.querySelector('.lbxv5-check__label');
      return norm(named ? named.textContent : label.textContent);
    }

    /* V119: Shopify paginates BEFORE JavaScript. Never remove an already
       paginated product from the grid: that leaves 1/24 items on page 2 while
       the server reports many results. Preserve exact size+color availability
       by marking the card rather than deleting it after pagination. */
    function variantFilterKind(input){
      var heading=filterHeading(input);
      var key=norm(input && input.name || '');
      if(heading.indexOf('talla')!==-1 || heading.indexOf('size')!==-1 || heading.indexOf('taille')!==-1 || heading.indexOf('taglia')!==-1 || heading.indexOf('maat')!==-1 || heading.indexOf('tamanho')!==-1 || heading.indexOf('cuadro')!==-1 || heading.indexOf('frame')!==-1 || key.indexOf('option talla')!==-1 || key.indexOf('option size')!==-1)return 'size';
      if(heading.indexOf('color')!==-1 || heading.indexOf('colour')!==-1 || heading.indexOf('farbe')!==-1 || heading.indexOf('couleur')!==-1 || heading.indexOf('colore')!==-1 || heading==='cor' || heading.indexOf('kleur')!==-1 || key.indexOf('option color')!==-1 || key.indexOf('option colour')!==-1)return 'color';
      return '';
    }

    function canonicalOptionValue(value){
      return norm(value).replace(/\b(unica|unico|unique)\b/g,'unica').trim();
    }

    function activeVariantSelections(){
      var selected={size:[],color:[]};
      if(!form)return selected;
      form.querySelectorAll('input[type="checkbox"]:checked,input[type="radio"]:checked').forEach(function(input){
        var kind=variantFilterKind(input);
        if(!kind)return;
        var value=canonicalOptionValue(input.value || labelForInput(input) || '');
        if(value && selected[kind].indexOf(value)===-1)selected[kind].push(value);
      });
      return selected;
    }

    function hasVariantSelections(selected){
      return !!(selected && ((selected.size&&selected.size.length) || (selected.color&&selected.color.length)));
    }

    function colorFamily(value){
      var text=' '+norm(value)+' ';
      var family={
        black:['negro','black','schwarz','noir','nero','preto','zwart'],
        white:['blanco','blanca','white','weiss','blanc','bianco','branco','wit'],
        gray:['gris','grey','gray','grau','grigio','cinza','silver','plata','argent'],
        blue:['azul','blue','blau','bleu','blu','navy'],
        green:['verde','green','grun','gruen','vert','olive'],
        red:['rojo','roja','red','rot','rouge','rosso','vermelho'],
        beige:['beige','arena','sand','cream','crema','creme','ivoire','ivory'],
        brown:['marron','brown','braun','brun','marrone','castano','cafe'],
        orange:['naranja','orange','arancione','laranja'],
        yellow:['amarillo','amarilla','yellow','gelb','jaune','giallo'],
        purple:['morado','morada','purple','violeta','violet','lila'],
        pink:['rosa','pink','rose'],
        gold:['dorado','dorada','gold','oro']
      };
      var found=[];
      for(var key in family){
        if(family[key].some(function(alias){return text.indexOf(' '+alias+' ')!==-1;}))found.push(key);
      }
      return found.length?found:[text.trim()];
    }
    function optionMatchesSelection(value,selections,kind){
      if(!selections || !selections.length)return true;
      var current=canonicalOptionValue(value);
      return selections.some(function(wanted){
        return current===wanted || (kind==='color' && colorFamily(current).some(function(f){return colorFamily(wanted).indexOf(f)!==-1;}));
      });
    }

    function parseVariantMatrix(card){
      var node=card && card.querySelector('[data-lbx-v103-variants]');
      if(!node)return null;
      try{
        var data=JSON.parse(node.textContent||'{}');
        if(!data || !Array.isArray(data.variants))return null;
        return data;
      }catch(e){return null;}
    }

    function scopedVariantAvailability(card,selected){
      if(!hasVariantSelections(selected))return null;
      var matrix=parseVariantMatrix(card);
      if(!matrix)return {provable:false,available:false,own:0,supplier:0,matches:[]};
      var sizePos=Math.max(0,Number(matrix.sizePosition||0));
      var colorPos=Math.max(0,Number(matrix.colorPosition||0));
      if((selected.size.length&&!sizePos)||(selected.color.length&&!colorPos))
        return {provable:false,available:false,own:0,supplier:0,matches:[]};
      var own=0;
      var supplier=0;
      var reservation=false;
      var live=card.__lbxLiveStock || {};
      var matches=[];
      (matrix.variants||[]).forEach(function(variant){
        var options=Array.isArray(variant.options)?variant.options:[];
        if(selected.size.length){
          if(!sizePos || !optionMatchesSelection(options[sizePos-1]||'',selected.size))return;
        }
        if(selected.color.length){
          if(!colorPos || !optionMatchesSelection(options[colorPos-1]||'',selected.color,'color'))return;
        }
        var current=live[String(variant.id)];
        if(!current || current.state==='unknown')return;
        var variantOwn=Math.max(0,Number(current.storeStock||0));
        var variantSupplier=Math.max(0,Number(current.supplierStock||0));
        if(current.state==='store')own+=variantOwn;
        if(current.state==='supplier')supplier+=variantSupplier;
        if(current.state==='incoming'||current.state==='assumed')reservation=true;
        matches.push(variant);
      });
      return {provable:matches.length>0,available:own>0||supplier>0||reservation,own:own,supplier:supplier,reservation:reservation,matches:matches};
    }

    function updateScopedAvailabilityCopy(card,scope){
      if(!scope || !scope.provable)return;
      card.__lbxSelectedVariant=scope.matches.length===1?scope.matches[0]:null;
      card.__lbxMatchedVariants=scope.matches;
      if(window.lbxHubAvailability)window.lbxHubAvailability.render(card,scope.own,scope.supplier);
    }

    function applyVariantAvailabilityFilter(scope){
      var selected=activeVariantSelections();
      var host=scope&&scope.querySelectorAll?scope:root;
      var cards=[].slice.call(host.querySelectorAll('[data-lbx-product-card]'));
      cards.forEach(function(card){
        /* Clear stale client filters; never disturb the independent offer gate. */
        card.classList.remove('lbxv118-variant-hidden');
        if(!card.classList.contains('lbxv87-offer-hidden'))card.hidden=false;
        card.removeAttribute('data-lbx-v119-option-unavailable');
        card.removeAttribute('data-lbx-v119-option-unverified');
        if(!hasVariantSelections(selected)){
          card.__lbxSelectedVariant=null;
          card.__lbxMatchedVariants=null;
          if(window.lbxHubAvailability)window.lbxHubAvailability.render(card,Number(card.getAttribute('data-lbx-all-own-stock')||0),Number(card.getAttribute('data-lbx-all-supplier-stock')||0));
          return;
        }
        var result=scopedVariantAvailability(card,selected);
        if(result && result.provable){
          updateScopedAvailabilityCopy(card,result);
          return;
        }
        /* Correct the stock claim for the CHOSEN combination, not some other
           size. The product remains in its genuine Shopify pagination slot. */
        card.__lbxMatchedVariants=[];
        if(window.lbxHubAvailability)window.lbxHubAvailability.render(card,0,0);
        var unverified=!result || !result.provable;
        card.setAttribute(unverified?'data-lbx-v119-option-unverified':'data-lbx-v119-option-unavailable','1');
        card.setAttribute('data-lbx-product-stock-status',unverified?'unverified-selection':'unavailable-selection');
        card.setAttribute('data-lbx-own-stock','0');
        card.setAttribute('data-lbx-supplier-stock','0');
        var availability=card.querySelector('[data-lbx-store-availability]');
        var label=availability&&availability.querySelector('.lbx109-stock-copy b');
        var detail=availability&&availability.querySelector('.lbx109-stock-copy small');
        if(availability){
          availability.classList.remove('is-available','is-supplier','is-sold-out');
          if(!unverified)availability.classList.add('is-sold-out');
        }
        if(label)label.textContent=unverified?'Consultar talla/color':'Talla/color sin disponibilidad';
        if(detail)detail.textContent=unverified?'Disponibilidad por confirmar':'Consulta otras variantes';
      });
      var oldEmpty=root.querySelector('[data-lbx-v118-empty]');
      if(oldEmpty)oldEmpty.remove();
      /* Leave collection.products_count and Shopify's native pages authoritative. */
      return {active:hasVariantSelections(selected),visible:cards.length};
    }

    function filterHeading(input){
      var details=input.closest('.lbxv5-filter');
      var summary=details && details.querySelector('summary');
      return norm(summary ? summary.textContent : '');
    }

    function matchesWanted(label,wanted,kind){
      if(!label||!wanted)return false;
      if(kind==='brand') return label===wanted || label.indexOf(wanted)!==-1 || wanted.indexOf(label)!==-1;
      var aliases={
        montana:['montana','mountain','mtb'],
        urbana:['urbana','urbanas','urban','city','ciudad'],
        trekking:['trekking','hibrida','hibridas','hybrid'],
        gravel:['gravel'],
        carga:['carga','cargo'],
        ninos:['nino','ninos','kids','infantil']
      };
      var list=aliases[wanted]||[wanted];
      return list.some(function(alias){ return label===alias || label.indexOf(alias)!==-1; });
    }

    function findPresetInput(kind,wanted){
      if(!form||!wanted)return null;
      var inputs=[].slice.call(form.querySelectorAll('input[type=\"checkbox\"],input[type=\"radio\"]'));
      var headingHints=kind==='brand'
        ? ['marca','brand','fabricante','vendor']
        : ['categoria','category','modalidad','disciplina','tipo','uso'];
      var candidates=inputs.filter(function(input){
        var heading=filterHeading(input);
        return headingHints.some(function(hint){ return heading.indexOf(hint)!==-1; });
      });
      var pool=candidates.length?candidates:inputs;
      return pool.find(function(input){
        var text=norm(labelForInput(input)+' '+(input.value||''));
        return matchesWanted(text,wanted,kind);
      })||null;
    }

    function translateMenuPresets(){
      if(!form)return false;
      var current=new URL(window.location.href);
      /* V58: repair old Trekking URLs generated as the legacy display label Híbrida. */
      var legacyCategoryParam=current.searchParams.get('filter.p.m.labosch.badge_categoria');
      if(norm(legacyCategoryParam)==='hibrida'){
        current.searchParams.set('filter.p.m.labosch.badge_categoria','Trekking');
        window.location.replace(current.href);
        return true;
      }
      var brand=norm(current.searchParams.get('lbx_brand')||current.searchParams.get('lbx_marca')||'');
      var category=norm(current.searchParams.get('lbx_cat')||'');
      if(!brand&&!category)return false;

      var next=new URL(current.href);
      var changed=false;

      if(brand){
        var brandInput=findPresetInput('brand',brand);
        if(brandInput && brandInput.name){
          next.searchParams.delete(brandInput.name);
          next.searchParams.append(brandInput.name,brandInput.value);
          changed=true;
        }else{
          var brandDisplay={
            amflow:'AMFLOW',berria:'BERRIA',bh:'BH',monty:'MONTY',cannondale:'CANNONDALE',focus:'FOCUS',ghost:'GHOST',
            haibike:'HAIBIKE',ktm:'KTM',lapierre:'LAPIERRE',megamo:'MEGAMO',moustache:'MOUSTACHE',
            'riese muller':'RIESE & MÜLLER',winora:'WINORA'
          }[brand]||brand.toUpperCase();
          next.searchParams.set('filter.p.vendor',brandDisplay);
          changed=true;
        }
        next.searchParams.delete('lbx_brand');
        next.searchParams.delete('lbx_marca');
      }

      if(category){
        var categoryInput=findPresetInput('category',category);
        if(categoryInput && categoryInput.name){
          next.searchParams.delete(categoryInput.name);
          next.searchParams.append(categoryInput.name,categoryInput.value);
          changed=true;
        }else{
          var categoryDisplay={
            montana:'Montaña',urbana:'Urbana',trekking:'Trekking',gravel:'Gravel',carga:'Carga',ninos:'Infantil'
          }[category]||category;
          next.searchParams.set('filter.p.m.labosch.badge_categoria',categoryDisplay);
          changed=true;
        }
        next.searchParams.delete('lbx_cat');
      }

      if(changed && next.href!==current.href){
        window.location.replace(next.href);
        return true;
      }
      return false;
    }

    if(translateMenuPresets())return;

    /* V87 — real offer mode for the V5 catalog. The menu already sends
       lbx_offer=1; V5 had stopped interpreting it, so it rendered the normal
       catalog. Keep the flag through filters/sort/pagination and show only
       cards that are genuinely on sale. */
    var currentParams=new URLSearchParams(window.location.search);
    var offerMode=currentParams.get('lbx_offer')==='1';
    var requestedSort=currentParams.get('sort_by')||'';
    var offerAutoSort=offerMode && (!requestedSort || requestedSort==='most-relevant' || requestedSort==='manual');
    function saveScrollPosition(){
      try{
        if('scrollRestoration' in history)history.scrollRestoration='manual';
        sessionStorage.setItem(scrollKey,JSON.stringify({y:window.scrollY||window.pageYOffset||0,t:Date.now()}));
      }catch(e){}
    }
    function offerRank(card){
      var own=Math.max(0,Number(card.getAttribute('data-lbx-own-stock')||0));
      var supplier=Math.max(0,Number(card.getAttribute('data-lbx-supplier-stock')||0));
      var discount=Math.max(0,Number(card.getAttribute('data-lbx-discount-pct')||0));
      var status=card.getAttribute('data-lbx-product-stock-status')||'';
      var tier=status==='in-stock'?4:(status==='supplier-stock'?3:(status==='reservation'?2:1));
      /* Own physical stock is the strongest signal, then discount quality.
         This keeps genuine LaBosch-stock offers ahead of supplier/no-stock deals. */
      return (tier*10000000)+(Math.min(own,999)*100000)+(Math.min(discount,100)*1000)+Math.min(supplier,999);
    }
    function sortOffersByOpportunity(){
      if(!offerAutoSort)return;
      var list=root.querySelector('[data-lbx-product-list]');
      if(!list)return;
      var cards=[].slice.call(list.querySelectorAll('[data-lbx-product-card]'));
      cards.sort(function(a,b){return offerRank(b)-offerRank(a);});
      cards.forEach(function(card){list.appendChild(card);});
    }
    function keepOfferParam(){
      if(!offerMode)return;
      [form,root.querySelector('[data-lbx-sort-form]')].forEach(function(f){
        if(!f||f.querySelector('input[name="lbx_offer"]'))return;
        var hidden=document.createElement('input');
        hidden.type='hidden';hidden.name='lbx_offer';hidden.value='1';f.appendChild(hidden);
      });
      root.querySelectorAll('.lbxv5-pagination a,.lbxv5-active a').forEach(function(a){
        try{var u=new URL(a.href,window.location.href);u.searchParams.set('lbx_offer','1');a.href=u.href;}catch(e){}
      });
    }
    function applyOfferMode(){
      if(!offerMode)return;
      root.classList.add('is-offer-mode');
      root.setAttribute('data-lbx-offer-mode','1');
      var cards=[].slice.call(root.querySelectorAll('[data-lbx-product-card]'));
      var visible=0;
      cards.forEach(function(card){
        var sale=card.getAttribute('data-lbx-sale')==='true';
        card.hidden=!sale;
        card.classList.toggle('lbxv87-offer-hidden',!sale);
        if(sale)visible++;
      });
      sortOffersByOpportunity();
      var count=root.querySelector('.lbxv5-toolbar p strong');
      if(count)count.textContent=String(visible);
      keepOfferParam();
    }

    function lbxOfferPageCount(scope){
      var pagination=scope && scope.querySelector && scope.querySelector('.lbxv5-pagination');
      if(!pagination)return 1;
      var declared=Number(pagination.getAttribute('data-lbx-pagination-total')||0);
      if(Number.isFinite(declared) && declared>0)return declared;
      return 1;
    }

    function lbxOfferCardKey(card){
      if(!card)return '';
      var handle=card.getAttribute('data-lbx-handle');
      if(handle)return 'h:'+handle;
      var a=card.querySelector('a[href*="/products/"]');
      return a?'u:'+String(a.getAttribute('href')||'').split('?')[0]:'';
    }

    function lbxSyncCompareButtons(scope){
      var selected=[];
      try{selected=JSON.parse(localStorage.getItem('lbxComparatorSelection')||'[]');if(!Array.isArray(selected))selected=[];}catch(e){selected=[];}
      (scope||document).querySelectorAll('[data-mg2-compare-handle]').forEach(function(button){
        var handle=button.getAttribute('data-mg2-compare-handle');
        var active=selected.indexOf(handle)!==-1;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',active?'true':'false');
        var label=button.querySelector('[data-mg2-compare-label]');
        if(label)label.textContent=active?(button.getAttribute('data-mg2-compare-label-active')||'Seleccionado'):(button.getAttribute('data-mg2-compare-label-idle')||'Comparar');
      });
    }

    /* V119: Offers are an additional client-only facet. Shopify paginates the
       base collection first, so hiding non-sale products on each server page
       produced nearly empty pages. Walk Shopify's REAL next links (including
       phcursor) and only swap the DOM once the complete index is verified.
       Then paginate the filtered sale set itself, at the configured page size. */
    var offerCatalogState=null;
    function offerPageSize(){
      var n=Number(root.getAttribute('data-lbx-per-page')||24);
      return Number.isFinite(n)?Math.max(1,Math.min(250,Math.floor(n))):24;
    }
    function offerUrlForPage(page){
      var u=new URL(window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('phcursor');
      u.searchParams.delete('section_id');
      u.searchParams.set('lbx_offer','1');
      if(page>1)u.searchParams.set('page',String(page));
      return u;
    }
    function nextShopifyOfferUrl(pageRoot,baseUrl){
      var a=pageRoot && pageRoot.querySelector('.lbxv5-pagination [data-lbx-pagination-next]');
      if(!a)return null;
      var u=new URL(a.getAttribute('href'),baseUrl);
      var preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview && !u.searchParams.has('preview_theme_id'))u.searchParams.set('preview_theme_id',preview);
      u.searchParams.delete('section_id');
      return u;
    }
    function renderOfferPage(page,historyMode){
      var state=offerCatalogState;
      if(!state)return;
      var perPage=offerPageSize();
      var totalPages=Math.max(1,Math.ceil(state.cards.length/perPage));
      var target=Math.max(1,Math.min(totalPages,Math.floor(Number(page)||1)));
      var list=root.querySelector('[data-lbx-product-list]');
      if(!list)return;
      list.innerHTML='';
      state.cards.slice((target-1)*perPage,target*perPage).forEach(function(card){
        card.hidden=false;
        card.classList.remove('lbxv87-offer-hidden');
        list.appendChild(card);
      });
      var count=root.querySelector('.lbxv5-toolbar p strong');
      if(count)count.textContent=String(state.cards.length);
      var pagination=root.querySelector('.lbxv5-pagination');
      if(!pagination){
        pagination=document.createElement('nav');
        list.insertAdjacentElement('afterend',pagination);
      }
      pagination.className='lbxv5-pagination lbxv119-offers-pagination';
      pagination.setAttribute('aria-label','Paginación de ofertas');
      pagination.setAttribute('data-lbx-offers-pagination','');
      pagination.setAttribute('data-lbx-pagination-current',String(target));
      pagination.setAttribute('data-lbx-pagination-total',String(totalPages));
      pagination.innerHTML='';
      if(target>1){
        var prev=document.createElement('a');
        prev.href=offerUrlForPage(target-1).href;
        prev.setAttribute('data-lbx-pagination-prev','');
        prev.textContent='← Anterior';
        pagination.appendChild(prev);
      }
      var label=document.createElement('span');
      label.textContent='Página '+target+' de '+totalPages;
      pagination.appendChild(label);
      if(target<totalPages){
        var next=document.createElement('a');
        next.href=offerUrlForPage(target+1).href;
        next.setAttribute('data-lbx-pagination-next','');
        next.textContent='Siguiente →';
        pagination.appendChild(next);
      }
      pagination.hidden=totalPages<=1;
      var oldEmpty=root.querySelector('[data-lbx-v87-offer-empty]');
      if(oldEmpty)oldEmpty.remove();
      if(!state.cards.length){
        var empty=document.createElement('div');
        empty.className='lbxv87-offer-empty';
        empty.setAttribute('data-lbx-v87-offer-empty','');
        empty.innerHTML='<strong>No hay e-bikes en oferta con estos filtros.</strong><span>Prueba a quitar algún filtro para ver más oportunidades.</span>';
        list.insertAdjacentElement('afterend',empty);
      }
      lbxSyncCompareButtons(list);
      state.page=target;
      if(historyMode){
        var targetUrl=offerUrlForPage(target).href;
        try{history[historyMode+'State']({lbxOfferPage:target},'',targetUrl);}catch(e){}
      }
      applyVariantAvailabilityFilter(list);
    }
    async function hydrateOfferCatalog(expectedSequence){
      if(!offerMode)return;
      if(expectedSequence && expectedSequence!==catalogAjaxSequence)return;
      offerCatalogState=null;
      applyOfferMode();
      var list=root.querySelector('[data-lbx-product-list]');
      if(!list)return;
      var expectedPages=lbxOfferPageCount(root);
      var requestedPage=Math.max(1,Number(new URL(window.location.href).searchParams.get('page')||1)||1);
      var firstUrl=offerUrlForPage(1);
      var sectionId=root.getAttribute('data-lbx-section-id');
      var seenKeys=new Set();
      var visitedUrls=new Set();
      var all=[];
      var pageRoot=root;
      var pageUrl=new URL(window.location.href);
      var scanned=0;
      root.classList.add('is-lbx100-offers-loading');
      try{
        /* A page-2 preview may carry a cursor. Start from canonical page 1
           instead of guessing page numbers with that stale cursor. */
        if(requestedPage!==1 || pageUrl.searchParams.has('phcursor')){
          pageRoot=null;
          pageUrl=firstUrl;
        }
        while(scanned<expectedPages){
          if(expectedSequence && expectedSequence!==catalogAjaxSequence)return;
          if(visitedUrls.has(pageUrl.href))throw new Error('Pagination cursor loop');
          visitedUrls.add(pageUrl.href);
          if(!pageRoot){
            var fetchUrl=new URL(pageUrl.href);
            if(sectionId)fetchUrl.searchParams.set('section_id',sectionId);
            var response=await fetch(fetchUrl.href,{
              credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'text/html'}
            });
            if(!response.ok)throw new Error('Catalog page HTTP '+response.status);
            var doc=new DOMParser().parseFromString(await response.text(),'text/html');
            pageRoot=doc.querySelector('[data-lbx-catalog]');
            if(!pageRoot)throw new Error('Catalog page markup missing');
          }
          var rawCards=[].slice.call(pageRoot.querySelectorAll('[data-lbx-product-card]'));
          if(!rawCards.length && expectedPages>1)throw new Error('Catalog page empty');
          rawCards.forEach(function(card){
            if(card.getAttribute('data-lbx-sale')!=='true')return;
            var key=lbxOfferCardKey(card);
            if(!key)throw new Error('Unidentified product in offer catalog');
            if(seenKeys.has(key))return;
            seenKeys.add(key);
            var node=pageRoot===root?card:document.importNode(card,true);
            node.hidden=false;
            node.classList.remove('lbxv87-offer-hidden');
            all.push(node);
          });
          scanned++;
          var nextUrl=nextShopifyOfferUrl(pageRoot,pageUrl.href);
          if(!nextUrl){
            if(scanned!==expectedPages)throw new Error('Catalog ended early');
            break;
          }
          if(scanned===expectedPages)throw new Error('Unexpected extra catalog page');
          pageUrl=nextUrl;
          pageRoot=null;
        }
        if(scanned!==expectedPages)throw new Error('Incomplete offer pagination');
        if(expectedSequence && expectedSequence!==catalogAjaxSequence)return;
        if(offerAutoSort)all.sort(function(a,b){return offerRank(b)-offerRank(a);});
        offerCatalogState={cards:all,page:1};
        renderOfferPage(requestedPage,requestedPage>Math.max(1,Math.ceil(all.length/offerPageSize()))?'replace':null);
        root.classList.add('is-lbx100-offers-ready');
        try{document.dispatchEvent(new CustomEvent('lbx:offer-catalog-ready',{detail:{count:all.length}}));}catch(e){}
      }catch(error){
        /* Fail closed: NEVER replace the native grid with a partial catalog.
           Keep Shopify pagination accessible and disclose incomplete indexing. */
        offerCatalogState=null;
        var pagination=root.querySelector('.lbxv5-pagination');
        if(pagination)pagination.hidden=false;
        var prior=root.querySelector('[data-lbx-v119-offer-warning]');
        if(prior)prior.remove();
        var warning=document.createElement('p');
        warning.setAttribute('data-lbx-v119-offer-warning','');
        warning.setAttribute('role','status');
        warning.textContent='No se han podido cargar todas las ofertas. Puedes seguir navegando por las páginas del catálogo.';
        list.insertAdjacentElement('beforebegin',warning);
        try{console.warn('LaBosch offers pagination:',error);}catch(e){}
      }finally{
        root.classList.remove('is-lbx100-offers-loading');
      }
    }

    Promise.resolve(hydrateOfferCatalog()).then(function(){
      applyVariantAvailabilityFilter(root.querySelector('.lbxv5-catalog__main')||root);
    });
    function openPanel(){
      if(!panel)return;
      panel.classList.add('is-open');
      document.documentElement.classList.add('lbxv5-filter-open');
      document.body.classList.add('lbxv5-filter-open');
      if(backdrop)backdrop.classList.add('is-open');
      if(panel)panel.setAttribute('aria-hidden','false');
      triggers.forEach(function(x){x.setAttribute('aria-expanded','true');});
    }
    function closePanel(){
      if(!panel)return;
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('lbxv5-filter-open');
      document.body.classList.remove('lbxv5-filter-open');
      if(backdrop)backdrop.classList.remove('is-open');
      if(panel)panel.setAttribute('aria-hidden','true');
      triggers.forEach(function(x){x.setAttribute('aria-expanded','false');});
    }
    function sortFilterValuesAlphabetically(){
      if(!form)return;
      form.querySelectorAll('.lbxv5-filter__values').forEach(function(group){
        var items=[].slice.call(group.children);
        if(items.length<2)return;
        items.sort(function(a,b){
          var aText=(a.getAttribute('title')||((a.querySelector('.lbxv5-check__label')||a).textContent)||'').trim();
          var bText=(b.getAttribute('title')||((b.querySelector('.lbxv5-check__label')||b).textContent)||'').trim();
          return aText.localeCompare(bText,document.documentElement.lang||'es',{sensitivity:'base',numeric:true});
        });
        items.forEach(function(item){group.appendChild(item);});
      });
    }
    triggers.forEach(function(x){x.addEventListener('click',openPanel);});
    closers.forEach(function(x){x.addEventListener('click',closePanel);});
    if(backdrop)backdrop.addEventListener('click',closePanel);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closePanel();});
    sortFilterValuesAlphabetically();
    /* V108 — Desktop batch/AJAX filtering.
       Users can tick several facets without a full document navigation. We wait
       briefly after the last interaction, cancel stale requests, replace only
       the catalog main area and keep the viewport/sidebar completely stable. */
    var desktopMedia=window.matchMedia ? window.matchMedia('(min-width:1025px)') : null;
    var desktopFilterTimer=0;
    var catalogAjaxController=null;
    var catalogAjaxSequence=0;

    function desktopAjaxFiltersEnabled(){
      return !!(desktopMedia && desktopMedia.matches && window.fetch && window.DOMParser && window.history && history.replaceState);
    }

    function cancelPendingCatalogAjax(){
      window.clearTimeout(desktopFilterTimer);
      desktopFilterTimer=0;
      if(catalogAjaxController){
        try{catalogAjaxController.abort();}catch(e){}
        catalogAjaxController=null;
      }
      root.classList.remove('is-ajax-loading');
    }

    function buildFilterUrl(){
      var url=new URL((form && form.action) || window.location.href,window.location.href);
      var data=form ? new FormData(form) : new FormData();
      data.forEach(function(value,key){
        var text=String(value == null ? '' : value).trim();
        if(text!=='')url.searchParams.append(key,text);
      });
      url.searchParams.delete('page');
      url.searchParams.delete('phcursor');
      if(offerMode)url.searchParams.set('lbx_offer','1');
      return url;
    }

    function inputKey(input){
      return String(input.name||'')+'\u0000'+String(input.value||'');
    }

    function syncDesktopFilterState(foreignRoot){
      if(!form||!foreignRoot)return;
      var remoteForm=foreignRoot.querySelector('[data-lbx-filter-form]');
      if(!remoteForm)return;
      var remoteInputs=new Map();
      remoteForm.querySelectorAll('input[type="checkbox"],input[type="radio"],input[type="number"]').forEach(function(input){
        remoteInputs.set(inputKey(input),input);
      });
      form.querySelectorAll('input[type="checkbox"],input[type="radio"],input[type="number"]').forEach(function(input){
        var remote=remoteInputs.get(inputKey(input));
        if(!remote)return;
        if(input.type==='checkbox'||input.type==='radio')input.checked=remote.checked;
        input.disabled=remote.disabled;
        var label=input.closest('label');
        var remoteLabel=remote.closest('label');
        if(label&&remoteLabel){
          label.classList.toggle('is-disabled',remoteLabel.classList.contains('is-disabled'));
          label.classList.toggle('is-active',remoteLabel.classList.contains('is-active'));
          var count=label.querySelector('small');
          var remoteCount=remoteLabel.querySelector('small');
          if(count&&remoteCount)count.textContent=remoteCount.textContent;
        }
      });
      var localDetails=[].slice.call(form.querySelectorAll('.lbxv5-filter'));
      var remoteDetails=[].slice.call(remoteForm.querySelectorAll('.lbxv5-filter'));
      localDetails.forEach(function(details,index){
        var summary=details.querySelector('summary');
        var remoteSummary=remoteDetails[index]&&remoteDetails[index].querySelector('summary');
        if(!summary||!remoteSummary)return;
        var badge=summary.querySelector('b');
        var remoteBadge=remoteSummary.querySelector('b');
        if(remoteBadge){
          if(!badge){badge=document.createElement('b');summary.appendChild(badge);}
          badge.textContent=remoteBadge.textContent;
        }else if(badge){
          badge.remove();
        }
      });
      var remoteSort=remoteForm.querySelector('input[name="sort_by"]');
      var localSort=form.querySelector('input[name="sort_by"]');
      if(remoteSort){
        if(!localSort){localSort=document.createElement('input');localSort.type='hidden';localSort.name='sort_by';form.prepend(localSort);}
        localSort.value=remoteSort.value;
      }
    }

    async function updateCatalogAjax(url,opts){
      opts=opts||{};
      url=url instanceof URL?url:new URL(url,window.location.href);
      if(offerMode)url.searchParams.set('lbx_offer','1');
      if(!desktopAjaxFiltersEnabled()){
        saveScrollPosition();
        window.location.assign(url.href||String(url));
        return;
      }
      if(catalogAjaxController){try{catalogAjaxController.abort();}catch(e){}}
      catalogAjaxController=new AbortController();
      var controller=catalogAjaxController;
      var sequence=++catalogAjaxSequence;
      var lockedY=window.scrollY||window.pageYOffset||0;
      root.classList.remove('is-loading');
      root.classList.add('is-ajax-loading');
      form&&form.classList.add('is-updating');
      try{
        /* Shopify Section Rendering API: fetch only this catalog section, not the
           whole page/header/footer. This keeps desktop filtering lightweight. */
        var requestUrl=new URL(url.href);
        var sectionId=root.getAttribute('data-lbx-section-id');
        if(sectionId)requestUrl.searchParams.set('section_id',sectionId);
        var response=await fetch(requestUrl.href,{
          credentials:'same-origin',
          signal:controller.signal,
          headers:{'X-Requested-With':'XMLHttpRequest','Accept':'text/html'}
        });
        if(!response.ok)throw new Error('HTTP '+response.status);
        var html=await response.text();
        if(sequence!==catalogAjaxSequence)return;
        var doc=new DOMParser().parseFromString(html,'text/html');
        var foreignRoot=doc.querySelector('[data-lbx-catalog]');
        var foreignMain=foreignRoot&&foreignRoot.querySelector('.lbxv5-catalog__main');
        var localMain=root.querySelector('.lbxv5-catalog__main');
        if(!foreignRoot||!foreignMain||!localMain)throw new Error('Catalog fragment missing');

        /* Main content is the only region replaced. Sidebar and its open groups stay put. */
        localMain.innerHTML=foreignMain.innerHTML;
        syncDesktopFilterState(foreignRoot);
        try{history.replaceState({lbxCatalog:true},'',url.href||String(url));}catch(e){}
        window.scrollTo(0,lockedY);
        requestAnimationFrame(function(){window.scrollTo(0,lockedY);});

        lbxSyncCompareButtons(localMain);
        try{document.dispatchEvent(new CustomEvent('lbx:catalog-updated',{detail:{url:String(url.href||url)}}));}catch(e){}
        if(offerMode)await hydrateOfferCatalog(sequence);
        applyVariantAvailabilityFilter(localMain);
      }catch(error){
        if(error&&error.name==='AbortError')return;
        /* Network/parser failure: fall back to the reliable server navigation. */
        saveScrollPosition();
        window.location.assign(url.href||String(url));
        return;
      }finally{
        if(sequence===catalogAjaxSequence){
          catalogAjaxController=null;
          submitting=false;
          root.classList.remove('is-ajax-loading');
          form&&form.classList.remove('is-updating','is-dirty');
        }
      }
    }

    function scheduleDesktopFilterUpdate(delay){
      if(!desktopAjaxFiltersEnabled())return;
      window.clearTimeout(desktopFilterTimer);
      /* A new choice invalidates any in-flight response immediately. */
      if(catalogAjaxController){try{catalogAjaxController.abort();}catch(e){}catalogAjaxController=null;}
      root.classList.remove('is-ajax-loading');
      desktopFilterTimer=window.setTimeout(function(){
        desktopFilterTimer=0;
        updateCatalogAjax(buildFilterUrl(),{reason:'filters'});
      },typeof delay==='number'?delay:550);
    }

    if(form){
      form.addEventListener('change',function(e){
        var target=e.target;
        if(!target)return;
        if(target.type==='checkbox'||target.type==='radio'||target.type==='number'){
          form.classList.add('is-dirty');
          if(desktopAjaxFiltersEnabled())scheduleDesktopFilterUpdate(target.type==='number'?700:550);
        }
      });
      form.addEventListener('input',function(e){
        var target=e.target;
        if(target&&target.type==='number'&&desktopAjaxFiltersEnabled()){
          form.classList.add('is-dirty');
          scheduleDesktopFilterUpdate(700);
        }
      });
      form.addEventListener('submit',function(e){
        if(desktopAjaxFiltersEnabled()){
          e.preventDefault();
          scheduleDesktopFilterUpdate(0);
          return;
        }
        if(submitting)return;
        saveScrollPosition();
        submitting=true;
        root.classList.add('is-loading');
      });
    }

    root.addEventListener('change',function(e){
      var sort=e.target.closest&&e.target.closest('[data-lbx-sort-select]');
      if(!sort)return;
      if(desktopAjaxFiltersEnabled()){
        var hidden=form&&form.querySelector('input[name="sort_by"]');
        if(hidden)hidden.value=sort.value;
        scheduleDesktopFilterUpdate(0);
      }else{
        var sortForm=sort.closest('form');
        if(sortForm){saveScrollPosition();root.classList.add('is-loading');sortForm.submit();}
      }
    });

    root.addEventListener('click',function(e){
      var filterLink=e.target.closest&&e.target.closest('.lbxv5-active a,.lbxv5-filter-form__actions a');
      if(filterLink&&desktopAjaxFiltersEnabled()){
        e.preventDefault();
        cancelPendingCatalogAjax();
        updateCatalogAjax(new URL(filterLink.href,window.location.href),{reason:'link'});
        return;
      }
      var paginationLink=e.target.closest&&e.target.closest('.lbxv5-pagination a');
      if(paginationLink && offerMode && offerCatalogState && paginationLink.closest('[data-lbx-offers-pagination]')){
        e.preventDefault();
        var targetPage=Number(new URL(paginationLink.href,window.location.href).searchParams.get('page')||1);
        renderOfferPage(targetPage,'push');
        var main=root.querySelector('.lbxv5-catalog__main');
        if(main){
          var header=document.querySelector('[data-mg2-header]');
          var offset=header?header.getBoundingClientRect().height:0;
          window.scrollTo(0,Math.max(0,main.getBoundingClientRect().top+window.scrollY-offset-12));
        }
        return;
      }
      if(paginationLink)saveScrollPosition();
    });

    window.addEventListener('popstate',function(){
      if(offerMode && offerCatalogState){
        var page=Math.max(1,Number(new URL(window.location.href).searchParams.get('page')||1)||1);
        renderOfferPage(page,null);
      }
    });
    document.addEventListener('lbx:hub-availability',function(){applyVariantAvailabilityFilter(root);});
    window.addEventListener('pageshow',function(){
      submitting=false;
      root.classList.remove('is-loading','is-ajax-loading');
      form&&form.classList.remove('is-updating');
      closePanel();
    });
  });
})();
